import { period } from "../shared";

import { IBAN_PAID, generateMockExpenseItem } from "./generators";

const EXPENSE_PAID_WITH_SESSIONS = generateMockExpenseItem({
  id: "exp-401",
  recipientName: "Bo Kristensen",
  recipientCrmId: 9001,
  IBAN: IBAN_PAID,
  amountInCents: 738_00,
  consumptionInWattHours: 455_000,
  paymentStatus: "Paid",
});

const EXPENSE_LOWERCASE_PAYEE = generateMockExpenseItem({
  id: "exp-402",
  recipientName: "bo kristensen",
  recipientCrmId: 9002,
  amountInCents: 512_00,
  consumptionInWattHours: 318_000,
  paymentStatus: "Not started",
});

const EXPENSE_OLDER_PERIOD = generateMockExpenseItem({
  id: "exp-403",
  recipientName: "Bo Kristensen",
  recipientCrmId: 9003,
  period: period(2026, 4),
  amountInCents: 331_75,
  consumptionInWattHours: 205_600,
  paymentStatus: "Failed",
});

const EXPENSE_UPPERCASE_PAYEE = generateMockExpenseItem({
  id: "exp-404",
  recipientName: "ANNA JENSEN",
  recipientCrmId: 9004,
  reportStatus: "Approved",
  period: period(2026, 5),
  amountInCents: 214_00,
  consumptionInWattHours: 132_000,
  paymentStatus: "In progress",
});

const EXPENSE_ACTIVE_STATUS = generateMockExpenseItem({
  id: "exp-405",
  recipientName: "Mikkel Sorensen",
  recipientCrmId: 9005,
  reportStatus: "Active",
  period: period(2026, 7),
  amountInCents: 143_20,
  consumptionInWattHours: 88_400,
  paymentStatus: "Awaiting funds",
});

const EXPENSE_NO_PERIOD_PENDING = generateMockExpenseItem({
  id: "exp-409",
  recipientName: "Yrsa Vestergaard",
  recipientCrmId: 9007,
  period: undefined,
  amountInCents: 88_25,
  consumptionInWattHours: 54_300,
  paymentStatus: "Not started",
});

const EXPENSE_DOWNLOAD_FAILS = generateMockExpenseItem({
  id: "exp-406",
  recipientName: "Zara Poulsen",
  recipientCrmId: 9006,
  reportStatus: "FundsReceived",
  period: undefined,
  IBAN: IBAN_PAID,
  amountInCents: 96_50,
  consumptionInWattHours: 61_000,
  paymentStatus: "Paid",
});

const EXPENSE_ON_APPROVED_REPORT = generateMockExpenseItem({
  id: "exp-407",
  recipientName: "Ida Lund",
  recipientCrmId: 9501,
  reportStatus: "Approved",
  period: period(2026, 5),
  amountInCents: 964_25,
  consumptionInWattHours: 612_500,
  paymentStatus: undefined,
});

const EXPENSE_ON_ACTIVE_REPORT = generateMockExpenseItem({
  id: "exp-408",
  recipientName: "Peter Dahl",
  recipientCrmId: 9601,
  reportStatus: "Active",
  period: period(2026, 7),
  amountInCents: 312_75,
  consumptionInWattHours: 198_400,
  paymentStatus: "Not started",
});

export {
  EXPENSE_ACTIVE_STATUS,
  EXPENSE_DOWNLOAD_FAILS,
  EXPENSE_LOWERCASE_PAYEE,
  EXPENSE_NO_PERIOD_PENDING,
  EXPENSE_OLDER_PERIOD,
  EXPENSE_ON_ACTIVE_REPORT,
  EXPENSE_ON_APPROVED_REPORT,
  EXPENSE_PAID_WITH_SESSIONS,
  EXPENSE_UPPERCASE_PAYEE,
};
